export default "__VITE_ASSET__Dy7rN5eD__"